function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    viewBox: "0 0 31.099 31.099",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1690"
    },
    d: "M28.87,1.714H2.229C1,1.714,0,2.714,0,3.944v18.704c0,1.23,1,2.23,2.229,2.23h7.394L9,27.328 c-0.054,0.237-0.218,0.961,0.235,1.526c0.192,0.242,0.564,0.531,1.234,0.531c0.297,0,0.644-0.051,1.137-0.17l18.139-4.501 l0.082-0.054c0.777-0.369,1.272-1.146,1.272-2.013V3.944C31.099,2.714,30.099,1.714,28.87,1.714z M29.099,22.647 c0,0.093-0.052,0.158-0.108,0.193l-17.859,4.432c-0.02,0.005-0.04,0.01-0.059,0.014l1.121-4.409H2.229 C2.104,22.877,2,22.775,2,22.647V3.944c0-0.127,0.104-0.23,0.229-0.23H28.87c0.126,0,0.229,0.103,0.229,0.23V22.647z  M25.473,13.149c0,1.319-1.069,2.388-2.388,2.388s-2.388-1.069-2.388-2.388s1.069-2.388,2.388-2.388S25.473,11.83,25.473,13.149z  M10.403,13.149c0,1.319-1.069,2.388-2.388,2.388s-2.388-1.069-2.388-2.388s1.069-2.388,2.388-2.388S10.403,11.83,10.403,13.149z  M17.938,13.149c0,1.319-1.069,2.388-2.388,2.388s-2.388-1.069-2.388-2.388s1.069-2.388,2.388-2.388S17.938,11.83,17.938,13.149z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.489b6de2eece3a75bb28c328f1bdedf5.svg";
export { ForwardRef as ReactComponent };